import getActivityEntityType from '@/components/activity/utils/getActivityEntityType'
import { ENTITY_TYPE } from '@/constants/entities'
import { GOAL_EVENT_TYPE } from '@/constants/goal'
import {
  getGoalPageRouteConfig,
  getInitiativePageRouteConfig,
  getKrPageRouteConfig
} from '@/utils/navigationConfigs'

/**
 * This provides some computed properties from activity.
 * Whichever component uses it, this mixin expects component to have "activity" property.
 */
export default {
  computed: {
    entityType() {
      return getActivityEntityType(this.activity)
    },
    entity() {
      let entity = {}
      switch (this.entityType) {
        case ENTITY_TYPE.GOAL:
          entity = this.activity.goal
          break
        case ENTITY_TYPE.KEY_RESULT:
          entity = this.activity.keyResult
          if (!entity) {
            if (this.activity.type === GOAL_EVENT_TYPE.AWARD) {
              entity = this.activity.award.context
            } else {
              entity = {
                goalId: this.activity.goalId,
                id: this.activity.keyResultId
              }
            }
          }
          break
        case ENTITY_TYPE.INITIATIVE:
        case ENTITY_TYPE.TASK:
          entity = this.activity.initiative
          break
        default:
          break
      }
      return entity
    }
  },
  methods: {
    getEntityHref(linkToEvent = false) {
      let location
      const entityId = this.entity.id
      const orgId = this.activity.organizationId
      const params = {}
      if (linkToEvent) {
        params.query = {
          event: this.activity.id
        }
      }
      switch (this.entityType) {
        case ENTITY_TYPE.GOAL:
          location = getGoalPageRouteConfig({ goalId: entityId, orgId, ...params })
          break
        case ENTITY_TYPE.KEY_RESULT:
          location = getKrPageRouteConfig({
            orgId,
            krId: entityId,
            ...params
          })
          break
        case ENTITY_TYPE.INITIATIVE:
        case ENTITY_TYPE.TASK:
          location = getInitiativePageRouteConfig({ initiativeId: entityId, orgId, ...params })
          break
      }
      return location
    }
  }
}
